/**
 * GitHub Integration Service
 * 
 * API functions for GitHub OAuth, repository management,
 * and Copilot PAT management.
 */
import api from './api';

// =====================================================================
// OAuth
// =====================================================================

export const getGitHubConnectUrl = async () => {
  const response = await api.get('/github/connect');
  return response.data;
};

export const getGitHubStatus = async () => {
  const response = await api.get('/github/status');
  return response.data;
};

export const disconnectGitHub = async () => {
  const response = await api.post('/github/disconnect');
  return response.data;
};

// =====================================================================
// Copilot PAT
// =====================================================================

export const saveCopilotToken = async (token) => {
  const response = await api.post('/github/copilot-token', { token });
  return response.data;
};

export const getCopilotTokenStatus = async () => {
  const response = await api.get('/github/copilot-token');
  return response.data;
};

export const deleteCopilotToken = async () => {
  const response = await api.delete('/github/copilot-token');
  return response.data;
};

// =====================================================================
// Repository
// =====================================================================

export const listRepos = async (page = 1, perPage = 30) => {
  const response = await api.get('/github/repos', {
    params: { page, per_page: perPage },
  });
  return response.data;
};

export const listBranches = async (owner, repo) => {
  const response = await api.get(`/github/repos/${owner}/${repo}/branches`);
  return response.data;
};

export const getRepoTree = async (owner, repo, branch = 'main') => {
  const response = await api.get(`/github/repos/${owner}/${repo}/tree`, {
    params: { branch },
  });
  return response.data;
};

export const getFileContent = async (owner, repo, path, ref) => {
  const response = await api.get(`/github/repos/${owner}/${repo}/file`, {
    params: { path, ref },
  });
  return response.data;
};

export const commitFile = async (owner, repo, data) => {
  const response = await api.post(`/github/repos/${owner}/${repo}/file`, data);
  return response.data;
};

export const createBranch = async (owner, repo, data) => {
  const response = await api.post(`/github/repos/${owner}/${repo}/branch`, data);
  return response.data;
};

// =====================================================================
// User Defaults
// =====================================================================

export const saveDefaults = async (data) => {
  const response = await api.post('/github/defaults', data);
  return response.data;
};

// =====================================================================
// Codespaces
// =====================================================================

export const listCodespaces = async () => {
  const response = await api.get('/github/codespaces');
  return response.data;
};

export const listMachines = async (owner, repo) => {
  const response = await api.get(`/github/codespaces/machines/${owner}/${repo}`);
  return response.data;
};

export const createCodespace = async (data) => {
  const response = await api.post('/github/codespaces', data);
  return response.data;
};

export const getCodespace = async (name) => {
  const response = await api.get(`/github/codespaces/${name}`);
  return response.data;
};

export const startCodespace = async (name) => {
  const response = await api.post(`/github/codespaces/${name}/start`);
  return response.data;
};

export const stopCodespace = async (name) => {
  const response = await api.post(`/github/codespaces/${name}/stop`);
  return response.data;
};

export const deleteCodespace = async (name) => {
  const response = await api.delete(`/github/codespaces/${name}`);
  return response.data;
};

export default {
  getGitHubConnectUrl,
  getGitHubStatus,
  disconnectGitHub,
  saveCopilotToken,
  getCopilotTokenStatus,
  deleteCopilotToken,
  listRepos,
  listBranches,
  getRepoTree,
  getFileContent,
  commitFile,
  createBranch,
  saveDefaults,
  listCodespaces,
  listMachines,
  createCodespace,
  getCodespace,
  startCodespace,
  stopCodespace,
  deleteCodespace,
};
